import React from 'react';
import { PaywallLayoutV2 } from './DEFAULT';
import { PaywallLayoutV3 } from './DEFAULT_REVERSE';
import { PAYWALL_LAYOUT_VERSION } from '../types';
import { PaywallLayoutAcademy } from './ACADEMY';
import { PaywallLayoutMailSingle } from './MAIL_SINGLE';
import { NewPaywallLayoutAcademy } from './NEW_ACADEMY';
import { PaywallLayoutWalkingDesign } from './WALKING_DESIGN';
import { PaywallLayoutWelcomeTrial } from './WELCOME_TRIAL';
import { PaywallLayoutPilates } from './PILATES';

export const PAYWALL_LAYOUT: Record<
	PAYWALL_LAYOUT_VERSION,
	(children: React.ReactNode) => React.ReactElement
> = {
	[PAYWALL_LAYOUT_VERSION.DEFAULT]: children => (
		<PaywallLayoutV2>
			<>{children}</>
		</PaywallLayoutV2>
	),
	[PAYWALL_LAYOUT_VERSION.DEFAULT_REVERSE]: children => (
		<PaywallLayoutV3>
			<>{children}</>
		</PaywallLayoutV3>
	),
	[PAYWALL_LAYOUT_VERSION.ACADEMY]: children => (
		<PaywallLayoutAcademy>
			<>{children}</>
		</PaywallLayoutAcademy>
	),
	[PAYWALL_LAYOUT_VERSION.NEW_ACADEMY]: children => (
		<NewPaywallLayoutAcademy>
			<>{children}</>
		</NewPaywallLayoutAcademy>
	),
	[PAYWALL_LAYOUT_VERSION.MAIL_SINGLE]: children => (
		<PaywallLayoutMailSingle>
			<>{children}</>
		</PaywallLayoutMailSingle>
	),
	[PAYWALL_LAYOUT_VERSION.WALKING_DESIGN]: children => (
		<PaywallLayoutWalkingDesign>
			<>{children}</>
		</PaywallLayoutWalkingDesign>
	),
	[PAYWALL_LAYOUT_VERSION.WELCOME_TRIAL]: children => (
		<PaywallLayoutWelcomeTrial>
			<>{children}</>
		</PaywallLayoutWelcomeTrial>
	),
	[PAYWALL_LAYOUT_VERSION.PILATES]: children => (
		<PaywallLayoutPilates>
			<>{children}</>
		</PaywallLayoutPilates>
	),
};
